import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

import { Fancybox } from "@fancyapps/ui";
try {
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('../frontpage/bootstrap-5.1.3-dist/js/bootstrap.bundle.min.js');
} catch (e) {}

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})


Fancybox.bind('[data-fancybox="gallery"]', {
  Thumbs: false,
  Toolbar: false,

  Image: {
    zoom: false,
    click: false,
    wheel: "slide",
  },
});

$("#btn-cari").on('click', function() {
    search();
});

$("[name='subject[]']").on('change', function() {
    search();
});

$("#input-cari").keyup(function(event) {
    event.preventDefault();
    if (event.keyCode === 13) {
        $("#btn-cari").click();
    }
});

function search() {
    const urlParams = new URLSearchParams(window.location.search);
    const newUrlParams = new URLSearchParams();

    
    if (urlParams.has('page')) {
        newUrlParams.set('page', urlParams.get('page'));
    }
    if ($('#input-cari').val()) {
        newUrlParams.set('search', $('#input-cari').val()); 
    }
   
    let data = $('#form-filter').serializeArray();
    data.forEach(item => {
        newUrlParams.append(item.name, item.value);
    });
    window.location.search = newUrlParams;
}

$(".read-book").click(function(event) {
    event.preventDefault();
    readBook($(this).data('title'), $(this).data('url'));
});

function readBook(title, url){
    $('#read-bookLabel').html(title);
    $('#read-book-frame').attr('data', url);

    let iframehght =  $(document).height();
    $('#read-book-frame').height(iframehght)

    const myModalAlternative = new bootstrap.Modal('#read-book', {
      backdrop: false
    }).show();
}